var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcReview(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 3C2.9 3 2.00977 3.9 2.00977 5L2.00195 16.998C2.00195 18.103 2.89695 19 4.00195 19H6V23L10 19H20C21.1 19 22 18.1 22 17V5C22 3.9 21.1 3 20 3H4ZM4 5H20V17H6H4.00195L4 5ZM12 6.0625L10.6719 9.20508L7.26562 9.49609L9.84766 11.7324L9.07227 15.0625L12 13.2969L14.9277 15.0625L14.1523 11.7266L16.7344 9.49023L13.3281 9.19922L12 6.0625Z",
    fill: "#FFFCEB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcReview);
export default __webpack_public_path__ + "static/media/ic_review.9d653ca9aacf6e93dfa3dc3da0b82367.svg";
export { ForwardRef as ReactComponent };